import { Store } from '@ngrx/store';
import { environment } from '@environment';
import * as fromCore from '@metutors/core/state';
import { map, Observable, withLatestFrom } from 'rxjs';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';

@Component({
  selector: 'metutors-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  selectedCurrency$: Observable<any>;
  isSignupNewsLetter$: Observable<boolean>;

  @Output() signupClicked: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;
  myDate = new Date();
  selectedLanguage: string;
  clientUrl = environment.clientUrl;

  constructor(
    private _fb: FormBuilder,
    private _store: Store<any>,
    private _translate: TranslateService
  ) {}

  get email(): AbstractControl | null {
    return this.form.get('email');
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    const email = this.form.value;
    this._store.dispatch(fromCore.signupNewsLetter(email));
    this.form.reset();
  }

  onOpenLanguageCurrencyModal(): void {
    this._store.dispatch(fromCore.openLanguageCurrencyModal());
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      email: [null, [Validators.required, Validators.email]],
    });

    this.isSignupNewsLetter$ = this._store.select(
      fromCore.selectIsSignNewsLetter
    );

    this.selectedCurrency$ = this._store
      .select(fromCore.selectCurrentCurrency)
      .pipe(
        withLatestFrom(this._store.select(fromCore.selectCurrenciesNames)),
        map(([currencySymbol, currencies]) => ({
          id: currencySymbol,
          name: `${currencies[currencySymbol]} (${currencySymbol})`,
        }))
      );

    this.selectedLanguage = this._translate.currentLang;
    this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.selectedLanguage = event.lang;
    });
  }
}
